// @flow

import { type ArgentineDocumentType } from './types';
import { stripNonMatching } from '@tectonics/utils/formatting';

export function normalizeDocument(documentType: ArgentineDocumentType, document: ?string): string {
  const normalized = document ? stripNonMatching(document, 'numeric') : '';
  return documentType === 'DNI'
    ? normalized.substr(0, 8)
    : normalized;
}
